<template>
  <div class="debts-providers">
    <Loader v-if="loaderEnabled" v-bind:logo="loaderLogo"></Loader>
    <!-- MAIN CONTAINER -->
    <b-row>
      <b-col md="12" lg="12" sm="12">
        <KTCodePreview>
          <!-- CONTENT -->
          <template v-slot:preview>
            <!-- FILTER COMPONENT -->
            <DebtProvidersFilter v-model="filters" :is-loading="onLoadingList" @apply-filters="onApplyFilters" />
            <!-- TABLE COMPONENT -->
            <DebtProvidersTable :data="mainList.dataset" :is-loading="onLoadingList" :current-page="apiParams.page"
              :page-size="apiParams.pageSize" :can-insert-transaction="canInsertTransaction" :totals="calculatedTotals"
              @view-detail="onViewDetail" @create-cash-transaction="onCreateCashTransaction"
              @create-bank-transaction="onCreateBankTransaction" />
            <!-- PAGINATION COMPONENT -->
            <!-- <DebtProvidersPagination
              :current-page="apiParams.page"
              :total-pages="mainList.totalPages"
              :total-items="mainList.total"
              @page-changed="onPageChanged"
            /> -->
            <b-row class="mt-4">
              <b-col>
                <p class="mt-3 text-dark" style="font-weight: 500">
                  Tổng số: {{ convertPrice(mainList.total) }}
                </p>
              </b-col>
              <b-col>

                <BPaginationNavCustom :number-of-pages="apiParams.pageSize || 10" :current-page="apiParams.page"
                  :total-page="mainList.totalPages" :linkParams="{}" @page-change="fetchMainData()" />
              </b-col>
            </b-row>

          </template>
        </KTCodePreview>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import Loader from '@/view/content/Loader.vue';
import { getToastInstance } from '@/utils/toastHelper';
import { mapGetters } from 'vuex';
import DebtProvidersService from './services/DebtProvidersService';
import DebtProvidersFilter from './components/DebtProvidersFilter.vue';
import DebtProvidersTable from './components/DebtProvidersTable.vue';
// import DebtProvidersPagination from './components/DebtProvidersPagination.vue';
import BPaginationNavCustom from '@/view/base/bootstrap/BPaginationNavCustom.vue';
import { convertPrice } from '@/utils/common'


export default {
  name: 'DebtProvidersList',
  components: {
    KTCodePreview,
    Loader,
    DebtProvidersFilter,
    DebtProvidersTable,
    // DebtProvidersPagination,
    BPaginationNavCustom,
  },
  data() {
    return {
      title: 'Công nợ nhà cung cấp',
      mainList: {
        dataset: [],
        total: 0,
        pages: 1,
      },
      apiParams: {
        page: 1,
        pageSize: 10,
        fromDate: null,
        toDate: null,
        providerId: null,
      },
      onLoadingList: false,
      filters: {
        fromDate: null,
        toDate: null,
        searchProvider: '',
        providerId: null,
      },
    };
  },
  mounted() {
    this.loadBreadcum();
  },
  async created() {
    this.loadBreadcum();
    this.fetchMainData();
  },
  methods: {
    convertPrice,
    ...getToastInstance(),

    /**
     * Fetch main debt data
     */
    async fetchMainData() {
      try {
        let page = this.$route.query.page || 1;
        if (!page) {
          page = 1;
        }

        // Update API params from filters
        this.apiParams.page = page;
        this.apiParams.type = this.$route.params.mode;
        this.apiParams.fromDate = this.filters.fromDate;
        this.apiParams.toDate = this.filters.toDate;
        this.apiParams.providerId = this.filters.providerId;

        this.onLoadingList = true;
        const response = await DebtProvidersService.getProviderDebts(
          this.apiParams,
        );
        this.mainList = response;
        this.onLoadingList = false;
      } catch (error) {
        console.error('Error fetching debt data:', error);
        this.makeToastFailure('Lỗi khi tải dữ liệu công nợ');
        this.onLoadingList = false;
      }
    },

    /**
     * Load breadcrumb navigation
     */
    loadBreadcum() {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: 'Kế toán', route: 'accountant' },
        { title: 'Công nợ' },
        { title: this.title },
      ]);
    },

    /**
     * Handle filter application
     */
    onApplyFilters(filterData) {
      this.filters = { ...filterData };
      this.$route.query.page = 1;
      this.$router.push({name: 'list-debt-providers' });
      this.fetchMainData();
    },

    /**
     * Handle page change
     */
    onPageChanged(page) {
      console.log('on page change ....', page);
      //Fix bug pagination
      this.apiParams.page = Number(page);
      this.fetchMainData();
      // this.$router.push({ query: { ...this.$route.query, page } });
    },

    /**
     * Handle view detail action
     */
    onViewDetail(item) {
      const queryObj = DebtProvidersService.buildDetailQuery(
        item,
        this.filters.fromDate,
        this.filters.toDate,
      );
      const { href } = this.$router.resolve({
        name: 'list-debt-supplierduedate',
        query: queryObj,
      });
      window.open(href, '_blank');
    },

    /**
     * Handle create cash transaction
     */
    onCreateCashTransaction(item) {
      const params = DebtProvidersService.buildTransactionParams(
        item,
        '2',
        '2',
      );
      this.$router.push({
        name: 'transaction',
        params: {
          ...params,
          mode: 'cash',
          action: 'add',
          id: 'new',
        },
      });
    },

    /**
     * Handle create bank transaction
     */
    onCreateBankTransaction(item) {
      const params = DebtProvidersService.buildTransactionParams(
        item,
        '2',
        '4',
      );
      this.$router.push({
        name: 'transaction',
        params: {
          ...params,
          mode: 'bank',
          action: 'add',
          id: 'new',
        },
      });
    },
  },
  computed: {
    ...mapGetters([
      'breadcrumbs',
      'pageTitle',
      'layoutConfig',
      'checkPermission',
    ]),

    /**
     * Check if loader should be enabled
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig('loader.type'));
    },

    /**
     * Get loader logo path
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig('loader.logo');
    },

    /**
     * Check permission to insert transactions
     */
    canInsertTransaction() {
      // return this.checkPermission('TRANSACTION_INSERT');
      return true;
    },

    /**
     * Calculate totals for table summary
     */
    calculatedTotals() {
      const dataset = this.mainList.dataset || [];
      return {
        totalPaidAmount: DebtProvidersService.calculateSumAmount(
          dataset,
          'paidAmount',
        ),
        totalAmount: DebtProvidersService.calculateSumAmount(dataset, 'amount'),
        totalDebtSum: DebtProvidersService.calculateSumCalAmount(
          dataset,
          'paidAmount',
          'amount',
        ),
        totalPaidSum: DebtProvidersService.calculateSumCalAmount(
          dataset,
          'amount',
          'paidAmount',
        ),
      };
    },
  },
  beforeRouteUpdate: function (to, from, next) {
    this.mode = to.params.mode;
    next();
  },
  watch: {
    mode: function (val) {
      this.mode = val;
      this.fetchMainData();
      this.loadBreadcum();
    },
  },
};
</script>

<style lang="scss" scoped>
.debts-providers {

  // Main container styling
  &__container {
    width: 100%;
    padding: 0;
  }

  // Component spacing
  &__filter {
    margin-bottom: 1.25rem;
  }

  &__table {
    margin-bottom: 1rem;
  }

  &__pagination {
    margin-top: 1rem;
  }

  // Legacy support for existing styles
  .icon:hover {
    background-color: #90c6fc;
  }

  .sttClass {
    width: 20px;
  }

  .break-line {
    white-space: break-spaces;
  }

  .link {
    color: unset;
    text-decoration: none;

    &:hover {
      text-decoration: underline !important;
    }
  }

  // Responsive design
  @media (max-width: 768px) {
    &__filter {
      margin-bottom: 1rem;
    }

    &__table {
      font-size: 0.875rem;
    }
  }

  @media (max-width: 576px) {
    &__filter {
      margin-bottom: 0.75rem;
    }

    &__table {
      font-size: 0.8rem;
    }
  }
}

// Global pagination styles (for backward compatibility)
:deep(.custom-pagination) {
  .page-item.disabled {
    cursor: not-allowed;

    &.bv-d-xs-down-none {
      .page-link {
        margin: 0.35rem 0.25rem;
        text-align: center;
      }
    }
  }
}
</style>
